module.exports = __webpack_public_path__ + "a72e044937c749a3b558fa7b6fc4929b.MP3";